import { FC, PropsWithChildren } from 'react'
import styles from '../style.module.less'

type PropType = FC<PropsWithChildren<{
  icon: string
  unit: string
  value: string
  label: string
  className?: string
}>>

const Index: PropType = ({icon, label, value, unit, className}) => {
  return (
    <div className={`flex align-center ${className}`}>
      <img className={styles['card-msg-item-icon']} src={icon} alt='' />
      <div className='flex-1'>
        <div>
          <span className='font-700 font-23 line-through text-999'>{value}</span>
          <span className='text-777 font-12'>&emsp;{unit}</span>
        </div>
        <div className='text-777 font-14'>{label}</div>
      </div>
    </div>
  )
}

export default Index
